export default __webpack_public_path__ + "static/media/banner_sobre_nos.dfc9ca65.png";